import React from 'react';
import '../Component/contactUS.css'
import cont from '../image/contact.png'
import link from '../image/link.png'
import git from '../image/git.png'
import whatapp from '../image/whatapp.png'
import mail from '../image/mail.png'

export default function ContactUS () {
  return (
    <>
    <div className='title-1' id='contact'>
    <h1 data-aos="fade-down">Contact Me<span id="line-2"></span></h1>
    </div>
    <section id="contact">
      <div className="contact-box">
        <div className="contact-links" data-aos="fade-right">
          <h2><img src={cont}/></h2>
          <div className="links">
            <div className="link">
              <a href='https://www.linkedin.com/in/waleed-ahmed-742247251/' target='blank'><img src={link} alt="linkedin" /></a>
            </div>
            <div className="link">
              <a href='https://github.com/WaleedAhmed06' target='blank'><img src={git} alt="github" /></a>
            </div>
            <div className="link">
              <a href='https://wa.me/03122602807' target='blank'><img src={whatapp} alt="What'sapp" /></a>
            </div>
            <div className="link">
              <a href='mailto:waleed.techverk@gmail.com' target='blank'><img src={mail} alt="email" /></a>
            </div>
          </div>
        </div>
        <div className="contact-form-wrapper" data-aos="fade-left">
          <form   action="https://formspree.io/f/mrgwdvzw"
            method="POST">
            <div className="form-item">
              <input type="text" name="name" required autoComplete='off' />
              <label>Name:</label>
            </div>
            <div className="form-item">
              <input type="email" name="email" required autoComplete='off' />
              <label>Email:</label>
            </div>
            <div className="form-item">
              <textarea className="" name="message" required autoComplete='off'></textarea>
              <label>Message:</label>
            </div>
            <button className="submit-btn">Send</button>
          </form>
        </div>
      </div>
    </section>
    </>
  );
};

